import React from "react";

import { useProgressBarContext } from "../../../ProgressBarView/context/ProgressBarContext";
import { getProgress } from "../../../ProgressBarView/util/getProgress";

import { Bar } from "./components/Bar";
import { Breakpoints } from "./components/Breakpoints";
import { Container } from "./components/Container";
import { PrimaryText } from "./components/PrimaryText";
import { ProgressBar } from "./components/ProgressBar";
import { SecondaryText } from "./components/SecondaryText";

export const ProgressBarWidget1 = () => {
  const { state } = useProgressBarContext();
  const progress = getProgress(state, () => 1 / state.breakpoints.length);
  return (
    <Container>
      <PrimaryText />
      <Bar
        innerCss={{
          padding: "15px 0 15px 0",
          height: 30,
        }}
      >
        <ProgressBar progress={progress} />
        <Breakpoints />
      </Bar>
      <SecondaryText />
    </Container>
  );
};
